<lib-date-range-field
  [ngModel]="rango()"
  [startLabelKey]="startLabel() || 'COMMON.DATE_RANGE.FROM'"
  [endLabelKey]="endLabel() || 'COMMON.DATE_RANGE.TO'"
  [referenceDate]="systemDate()"
  [minDate]="minDate() ?? null"
  [maxDate]="maxDate() ?? null"
  (ngModelChange)="alElegirRango($event)"
/>
